export const objectToArray = (obj, isMultiselect) => {
  return Object.entries(obj).reduce((array, [value, label]) => {
    if (isMultiselect) array.push({ id: value, name: label });
    else array.push({ value, label });

    return array;
  }, []);
};
